<template>
	<div class="popup-card" v-hammer:tap="close">
		<div class="content">
			<!-- <div v-if="popup.card.rarity" class="rarity" :class="popup.card.rarity">
				<div class="icon"></div>
				<span class="text">{{ popup.card.rarity + '_card' | lang }}</span>
			</div> -->
			<div class="name">{{ popup.card[lang].name }}</div>
			<div class="card-wrap">
				<card :card="popup.card" />
			</div>
			<div v-if="popup.example" class="example">{{ 'card_example' | lang }}</div>
			<ui-text v-if="description" class="description" :text="description" :replaces="replaces" />
		</div>
		<ui-close-hint>{{ 'tap_anywhere_to_close' | lang }}</ui-close-hint>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { get_card_value } from '@/js/dungeon'
import Card from '@/components/global/card'
import UiText from '@/components/ui/ui-text'
import UiCloseHint from '@/components/ui/ui-close-hint'

export default {
	name: 'popup-card',
	props: {
		popup: { default: null }
	},
	computed: {
		...mapGetters([ 'lang', 'user' ]),
		description() {
			if (this.popup.card[this.lang].description) {
				if (this.popup.blindness) return this.popup.card[this.lang].description.replace('(X)', '?').replace('(s)', '')
				return this.popup.card[this.lang].description
			}
			return ""
		},
		replaces() {
			let replaces = []
			
			// if (get_card_value(this.popup.card) !== null) replaces.push({ '(X)': get_card_value(this.popup.card) })
			// if (get_card_value(this.popup.card) !== null) replaces.push({ '(s)': (get_card_value(this.popup.card) > 1) ? 's' : '' })

			return replaces
		}
	},
	methods: {
		close(e) {
			if (!e.srcEvent.stopped) this.$emit('close')
		}
	},
	components: { Card, UiText, UiCloseHint }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'


.popup-card
	absolute 0
	color light
	flex center center
	text-align center
	.content
		// height 100%
		max-width 360px
		margin 0 auto
		flex center center column
		transform translateY(-24px)
		> .name
			width 100%
			font-size 4rem
			text-align center
			line-height 0.8em
		> .rarity
			margin 0 0 8px 0
			opacity 1
			color #D1B995
			flex center center
			font-size 2rem
			.icon
				display inline-block
				width 8px
				height 8px
				margin 0 12px 0 0
				box-shadow 0 0 0 3px #D1B995
				transform rotate(45deg) translate(-1px, -1px)
			&.common .icon
				background-color darken(dark, 25%)
			&.rare .icon
				background-color #047bd0
			&.legendary .icon
				background-color #b400ff
		.card-wrap
			margin 72px 0
			width 100%
			flex center center
			transform scale(1.5)
			// >>> .card .face .name
			// 	display none
		.example
			width 100%
			margin -12px 0 16px 0
			text-align center
			font-size 2rem
			line-height 1em
			opacity 0.5
		.description
			width 100%
			margin 0 0 16px 0
			font-size 2.4rem
			text-align center
			&:last-child
				margin 0
			>>> .ui-score
				transform translateY(1px)
		.buttons
			padding 16px 0 0 0
		.deactivate-warning
			margin 16px 0 0 0
			opacity 0.5
			font-size 2rem

</style>
